  const exportTableDataToCSV = (table,fileName) => {
    
    if (!table) return;
    const rows = Array.from(table.querySelectorAll("tr"));
    const csvContent = rows
      .map((row) => {
        const cells = Array.from(row.querySelectorAll("th, td"));
        const rowValues = [];

        cells.forEach((cell) => {
          const text = cell.innerText.replace(/"/g, '""');
          const escapedText = `"${text}"`;
          
          // Get the colspan value (defaults to 1 if not specified)
          const colSpan = parseInt(cell.getAttribute("colSpan") || "1", 10);

          // Push the actual text for the first span
          rowValues.push(escapedText);

          // Push empty quotes for the remaining spanned columns to keep alignment straight
          for (let i = 1; i < colSpan; i++) {
            rowValues.push('""');
          }
        });

        return rowValues.join(",");
      })
      .join("\n");

    // Create a Blob and trigger the browser download
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName+".csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  export default exportTableDataToCSV;